import { ApiKeys } from '@app/constants/api-keys'
import { IInstitutionSchedule } from '@app/interfaces/organization/institution-schedule'
import { resolveTParams } from '@app/utils/resolve-params/resolve-params'
import localforage from 'localforage'
import { emptyOrganizationApi } from '.'
import { IRtkResponse } from '../../types'

export const institutionScheduleApi = emptyOrganizationApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getInstitutionSchedules: build.query<
      IRtkResponse<IInstitutionSchedule[]>,
      URLSearchParams | string
    >({
      query: (args = '') => ({
        url: 'dictionary/api/v1/institution-schedule',
        method: 'get',
        params: {
          ...resolveTParams(args),
        },
      }),
      transformResponse: (response: IInstitutionSchedule[], meta) => {
        return { response, meta }
      },
      providesTags: (data) =>
        data
          ? [
              ...data.response.map(({ id }) => ({
                type: ApiKeys.institutionSchedule,
                id,
              })),
              { type: ApiKeys.institutionSchedule, id: 'LIST' },
            ]
          : [{ type: ApiKeys.institutionSchedule, id: 'LIST' }],
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          localforage.setItem(ApiKeys.institutionSchedule, data?.response)
        } catch (e) {
          console.error(e)
        }
      },
    }),
    getInstitutionSchedule: build.query<IInstitutionSchedule, number>({
      query: (id) => ({
        url: `dictionary/api/v1/institution-schedule/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [
        { type: ApiKeys.institutionSchedule, id },
      ],
    }),
  }),
})

export const {
  useGetInstitutionSchedulesQuery,
  useGetInstitutionScheduleQuery,
} = institutionScheduleApi
